module.exports = __webpack_public_path__ + "static/media/check-circle.356038d9.svg";